module.exports = __webpack_public_path__ + "img/official.a58d6534.png";